import { IDvd } from '../../models/article.model';
import { EntityActions } from '../entity.actions';

export const fromDvdActions = {
	...EntityActions.create<IDvd>('[Dvd]'),
};
